export const MIN_CALENDAR_DATE_OFFSET = 2;
export const MAX_CALENDAR_DATE_OFFSET = 340;
export const MIN_BOOKING_DATE_OFFSET = 3;
export const MAX_BOOKING_DATE_OFFSET = 28;
